import { createSlice } from "@reduxjs/toolkit";
import { initialStateProps } from '../interfaces/colors';

const initialState : initialStateProps = {
    colors: [
        {
            code: "#ffffff",
            label: "blanco"
        },
        {
            code: "#AD0F0F",
            label: "rojo"
        },
        {
            code: "#cccccc",
            label: "gris"
        }
    ]
}

const colorsSlice = createSlice({
    name: "colors",
    initialState,
    reducers: {
        setColor: (state, action) => {
            state.colors = [
                ...state.colors, 
                {
                    code: action.payload.code, 
                    label: action.payload.label, 
                }
            ];
        },
    }
})

export const {
    setColor
} =
    colorsSlice.actions;

export default colorsSlice.reducer;